var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetaSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 822,
    height: 224,
    viewBox: "0 0 822 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_837)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 822,
    height: 224,
    rx: 24,
    fill: "#021D1D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 73.2221,
    width: 504.815,
    height: 0.91618,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 60.3954,
    width: 504.815,
    height: 0.91618,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 163.924,
    width: 504.815,
    height: 0.91618,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 152.93,
    width: 504.815,
    height: 0.91618,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.051,
    y: 21,
    width: 0.91618,
    height: 183.236,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.348,
    y: 21,
    width: 0.91618,
    height: 183.236,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.482,
    y: 21,
    width: 0.91618,
    height: 183.236,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.177,
    y: 21,
    width: 0.91618,
    height: 183.236,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-110-outside-1_75_837",
    maskUnits: "userSpaceOnUse",
    x: 215,
    y: 61,
    width: 390,
    height: 104,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 215,
    y: 61,
    width: 390,
    height: 104
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 154.123L229.178 158.585C237.386 136.801 246.387 116.852 257.508 101.104C268.097 86.1435 277.893 78.5324 283.982 76.1706C290.071 73.8088 291.129 76.9579 290.071 82.733C289.013 89.031 285.307 97.6938 282.127 105.569C277.89 115.542 273.126 126.828 273.126 135.491C273.126 143.628 278.684 149.926 285.834 149.926C293.778 149.926 300.661 140.74 306.22 133.39C317.073 118.43 325.811 111.344 320.516 130.764C318.134 140.737 316.015 149.138 322.104 157.272C327.663 164.884 339.047 166.984 349.373 158.585L342.49 148.613C334.546 154.123 330.312 151.762 331.106 143.625C331.637 138.375 335.343 129.451 335.343 121.579C335.343 112.393 328.991 106.092 321.047 106.356C311.781 106.618 303.837 117.117 297.485 124.992C294.572 128.667 287.425 139.427 286.101 137.065C283.982 133.39 291.132 117.642 294.308 110.557C298.809 99.2712 303.574 87.9852 303.574 79.0611C303.574 68.5624 296.16 62 287.159 62C265.979 61.9971 235.797 102.156 217 154.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48 74.8304C415.132 74.8304 421.828 76.6217 426.567 80.2044C431.382 83.7871 433.789 88.788 433.789 95.207C433.789 99.9093 432.511 103.791 429.953 106.851C427.47 109.836 423.859 111.852 419.119 112.897C430.931 114.912 436.836 121.07 436.836 131.37C436.836 138.162 434.278 143.499 429.163 147.38C424.122 151.261 416.9 153.202 407.496 153.202H377.478V74.8304H406.48ZM390.456 108.082H406.819C411.258 108.082 414.681 107.075 417.088 105.059C419.571 103.044 420.812 100.282 420.812 96.7744C420.812 93.2664 419.571 90.542 417.088 88.6014C414.681 86.5861 411.258 85.5785 406.819 85.5785H390.456V108.082ZM390.456 142.342H407.609C412.725 142.342 416.637 141.334 419.345 139.319C422.129 137.229 423.52 134.355 423.52 130.698C423.52 126.892 422.129 123.943 419.345 121.853C416.561 119.763 412.649 118.718 407.609 118.718H390.456V142.342Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.504 124.652C445.504 118.756 446.671 113.606 449.003 109.202C451.41 104.724 454.72 101.29 458.933 98.9017C463.222 96.4386 468.112 95.207 473.604 95.207C479.171 95.207 484.061 96.3266 488.274 98.5658C492.562 100.805 495.91 103.977 498.317 108.082C500.8 112.188 502.079 117.002 502.154 122.525C502.154 124.018 502.041 125.548 501.815 127.115H458.256V127.787C458.557 132.788 460.137 136.744 462.996 139.655C465.855 142.566 469.654 144.021 474.393 144.021C478.155 144.021 481.315 143.163 483.873 141.446C486.431 139.655 488.123 137.154 488.951 133.945H501.138C500.085 139.767 497.226 144.544 492.562 148.276C487.973 152.008 482.218 153.874 475.296 153.874C469.278 153.874 464.012 152.679 459.498 150.291C455.059 147.828 451.598 144.394 449.116 139.991C446.708 135.587 445.504 130.474 445.504 124.652ZM489.741 118.271C489.214 114.091 487.521 110.844 484.663 108.53C481.879 106.142 478.343 104.947 474.055 104.947C470.068 104.947 466.607 106.179 463.673 108.642C460.814 111.031 459.159 114.24 458.708 118.271H489.741Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.29 106.515H505.247V95.8788H515.29V79.8686H527.591V95.8788H541.471V106.515H527.591V136.408C527.591 138.647 528.042 140.252 528.945 141.222C529.848 142.118 531.39 142.566 533.572 142.566H542.825V153.202H531.089C525.597 153.202 521.572 151.933 519.014 149.395C516.532 146.858 515.29 142.939 515.29 137.64V106.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 142.678V153.202H597.568C593.806 153.202 591.098 152.418 589.443 150.851C587.788 149.283 586.96 147.007 586.96 144.021C582.597 150.59 576.24 153.874 567.889 153.874C561.419 153.874 556.228 152.381 552.316 149.395C548.404 146.41 546.448 142.305 546.448 137.08C546.448 131.183 548.554 126.668 552.767 123.533C556.98 120.323 563.112 118.718 571.161 118.718H585.719V115.248C585.719 112.038 584.59 109.538 582.333 107.746C580.076 105.88 576.954 104.947 572.967 104.947C569.431 104.947 566.497 105.731 564.165 107.299C561.908 108.791 560.554 110.807 560.102 113.344H548.14C548.742 107.597 551.3 103.156 555.814 100.021C560.328 96.8118 566.234 95.207 573.531 95.207C581.28 95.207 587.261 96.9984 591.474 100.581C595.687 104.164 597.793 109.314 597.793 116.031V138.647C597.793 141.334 599.072 142.678 601.63 142.678H604ZM585.719 127.675H570.597C566.835 127.675 563.939 128.422 561.908 129.914C559.877 131.333 558.861 133.46 558.861 136.296C558.861 138.759 559.801 140.737 561.682 142.23C563.638 143.723 566.271 144.469 569.581 144.469C574.622 144.469 578.534 143.126 581.318 140.439C584.176 137.752 585.643 134.169 585.719 129.69V127.675Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217 154.123L229.178 158.585C237.386 136.801 246.387 116.852 257.508 101.104C268.097 86.1435 277.893 78.5324 283.982 76.1706C290.071 73.8088 291.129 76.9579 290.071 82.733C289.013 89.031 285.307 97.6938 282.127 105.569C277.89 115.542 273.126 126.828 273.126 135.491C273.126 143.628 278.684 149.926 285.834 149.926C293.778 149.926 300.661 140.74 306.22 133.39C317.073 118.43 325.811 111.344 320.516 130.764C318.134 140.737 316.015 149.138 322.104 157.272C327.663 164.884 339.047 166.984 349.373 158.585L342.49 148.613C334.546 154.123 330.312 151.762 331.106 143.625C331.637 138.375 335.343 129.451 335.343 121.579C335.343 112.393 328.991 106.092 321.047 106.356C311.781 106.618 303.837 117.117 297.485 124.992C294.572 128.667 287.425 139.427 286.101 137.065C283.982 133.39 291.132 117.642 294.308 110.557C298.809 99.2712 303.574 87.9852 303.574 79.0611C303.574 68.5624 296.16 62 287.159 62C265.979 61.9971 235.797 102.156 217 154.123Z",
    fill: "url(#paint0_linear_75_837)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48 74.8304C415.132 74.8304 421.828 76.6217 426.567 80.2044C431.382 83.7871 433.789 88.788 433.789 95.207C433.789 99.9093 432.511 103.791 429.953 106.851C427.47 109.836 423.859 111.852 419.119 112.897C430.931 114.912 436.836 121.07 436.836 131.37C436.836 138.162 434.278 143.499 429.163 147.38C424.122 151.261 416.9 153.202 407.496 153.202H377.478V74.8304H406.48ZM390.456 108.082H406.819C411.258 108.082 414.681 107.075 417.088 105.059C419.571 103.044 420.812 100.282 420.812 96.7744C420.812 93.2664 419.571 90.542 417.088 88.6014C414.681 86.5861 411.258 85.5785 406.819 85.5785H390.456V108.082ZM390.456 142.342H407.609C412.725 142.342 416.637 141.334 419.345 139.319C422.129 137.229 423.52 134.355 423.52 130.698C423.52 126.892 422.129 123.943 419.345 121.853C416.561 119.763 412.649 118.718 407.609 118.718H390.456V142.342Z",
    fill: "url(#paint1_linear_75_837)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.504 124.652C445.504 118.756 446.671 113.606 449.003 109.202C451.41 104.724 454.72 101.29 458.933 98.9017C463.222 96.4386 468.112 95.207 473.604 95.207C479.171 95.207 484.061 96.3266 488.274 98.5658C492.562 100.805 495.91 103.977 498.317 108.082C500.8 112.188 502.079 117.002 502.154 122.525C502.154 124.018 502.041 125.548 501.815 127.115H458.256V127.787C458.557 132.788 460.137 136.744 462.996 139.655C465.855 142.566 469.654 144.021 474.393 144.021C478.155 144.021 481.315 143.163 483.873 141.446C486.431 139.655 488.123 137.154 488.951 133.945H501.138C500.085 139.767 497.226 144.544 492.562 148.276C487.973 152.008 482.218 153.874 475.296 153.874C469.278 153.874 464.012 152.679 459.498 150.291C455.059 147.828 451.598 144.394 449.116 139.991C446.708 135.587 445.504 130.474 445.504 124.652ZM489.741 118.271C489.214 114.091 487.521 110.844 484.663 108.53C481.879 106.142 478.343 104.947 474.055 104.947C470.068 104.947 466.607 106.179 463.673 108.642C460.814 111.031 459.159 114.24 458.708 118.271H489.741Z",
    fill: "url(#paint2_linear_75_837)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.29 106.515H505.247V95.8788H515.29V79.8686H527.591V95.8788H541.471V106.515H527.591V136.408C527.591 138.647 528.042 140.252 528.945 141.222C529.848 142.118 531.39 142.566 533.572 142.566H542.825V153.202H531.089C525.597 153.202 521.572 151.933 519.014 149.395C516.532 146.858 515.29 142.939 515.29 137.64V106.515Z",
    fill: "url(#paint3_linear_75_837)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 142.678V153.202H597.568C593.806 153.202 591.098 152.418 589.443 150.851C587.788 149.283 586.96 147.007 586.96 144.021C582.597 150.59 576.24 153.874 567.889 153.874C561.419 153.874 556.228 152.381 552.316 149.395C548.404 146.41 546.448 142.305 546.448 137.08C546.448 131.183 548.554 126.668 552.767 123.533C556.98 120.323 563.112 118.718 571.161 118.718H585.719V115.248C585.719 112.038 584.59 109.538 582.333 107.746C580.076 105.88 576.954 104.947 572.967 104.947C569.431 104.947 566.497 105.731 564.165 107.299C561.908 108.791 560.554 110.807 560.102 113.344H548.14C548.742 107.597 551.3 103.156 555.814 100.021C560.328 96.8118 566.234 95.207 573.531 95.207C581.28 95.207 587.261 96.9984 591.474 100.581C595.687 104.164 597.793 109.314 597.793 116.031V138.647C597.793 141.334 599.072 142.678 601.63 142.678H604ZM585.719 127.675H570.597C566.835 127.675 563.939 128.422 561.908 129.914C559.877 131.333 558.861 133.46 558.861 136.296C558.861 138.759 559.801 140.737 561.682 142.23C563.638 143.723 566.271 144.469 569.581 144.469C574.622 144.469 578.534 143.126 581.318 140.439C584.176 137.752 585.643 134.169 585.719 129.69V127.675Z",
    fill: "url(#paint4_linear_75_837)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 154.123L229.178 158.585C237.386 136.801 246.387 116.852 257.508 101.104C268.097 86.1435 277.893 78.5324 283.982 76.1706C290.071 73.8088 291.129 76.9579 290.071 82.733C289.013 89.031 285.307 97.6938 282.127 105.569C277.89 115.542 273.126 126.828 273.126 135.491C273.126 143.628 278.684 149.926 285.834 149.926C293.778 149.926 300.661 140.74 306.22 133.39C317.073 118.43 325.811 111.344 320.516 130.764C318.134 140.737 316.015 149.138 322.104 157.272C327.663 164.884 339.047 166.984 349.373 158.585L342.49 148.613C334.546 154.123 330.312 151.762 331.106 143.625C331.637 138.375 335.343 129.451 335.343 121.579C335.343 112.393 328.991 106.092 321.047 106.356C311.781 106.618 303.837 117.117 297.485 124.992C294.572 128.667 287.425 139.427 286.101 137.065C283.982 133.39 291.132 117.642 294.308 110.557C298.809 99.2712 303.574 87.9852 303.574 79.0611C303.574 68.5624 296.16 62 287.159 62C265.979 61.9971 235.797 102.156 217 154.123Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-110-outside-1_75_837)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48 74.8304C415.132 74.8304 421.828 76.6217 426.567 80.2044C431.382 83.7871 433.789 88.788 433.789 95.207C433.789 99.9093 432.511 103.791 429.953 106.851C427.47 109.836 423.859 111.852 419.119 112.897C430.931 114.912 436.836 121.07 436.836 131.37C436.836 138.162 434.278 143.499 429.163 147.38C424.122 151.261 416.9 153.202 407.496 153.202H377.478V74.8304H406.48ZM390.456 108.082H406.819C411.258 108.082 414.681 107.075 417.088 105.059C419.571 103.044 420.812 100.282 420.812 96.7744C420.812 93.2664 419.571 90.542 417.088 88.6014C414.681 86.5861 411.258 85.5785 406.819 85.5785H390.456V108.082ZM390.456 142.342H407.609C412.725 142.342 416.637 141.334 419.345 139.319C422.129 137.229 423.52 134.355 423.52 130.698C423.52 126.892 422.129 123.943 419.345 121.853C416.561 119.763 412.649 118.718 407.609 118.718H390.456V142.342Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-110-outside-1_75_837)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.504 124.652C445.504 118.756 446.671 113.606 449.003 109.202C451.41 104.724 454.72 101.29 458.933 98.9017C463.222 96.4386 468.112 95.207 473.604 95.207C479.171 95.207 484.061 96.3266 488.274 98.5658C492.562 100.805 495.91 103.977 498.317 108.082C500.8 112.188 502.079 117.002 502.154 122.525C502.154 124.018 502.041 125.548 501.815 127.115H458.256V127.787C458.557 132.788 460.137 136.744 462.996 139.655C465.855 142.566 469.654 144.021 474.393 144.021C478.155 144.021 481.315 143.163 483.873 141.446C486.431 139.655 488.123 137.154 488.951 133.945H501.138C500.085 139.767 497.226 144.544 492.562 148.276C487.973 152.008 482.218 153.874 475.296 153.874C469.278 153.874 464.012 152.679 459.498 150.291C455.059 147.828 451.598 144.394 449.116 139.991C446.708 135.587 445.504 130.474 445.504 124.652ZM489.741 118.271C489.214 114.091 487.521 110.844 484.663 108.53C481.879 106.142 478.343 104.947 474.055 104.947C470.068 104.947 466.607 106.179 463.673 108.642C460.814 111.031 459.159 114.24 458.708 118.271H489.741Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-110-outside-1_75_837)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.29 106.515H505.247V95.8788H515.29V79.8686H527.591V95.8788H541.471V106.515H527.591V136.408C527.591 138.647 528.042 140.252 528.945 141.222C529.848 142.118 531.39 142.566 533.572 142.566H542.825V153.202H531.089C525.597 153.202 521.572 151.933 519.014 149.395C516.532 146.858 515.29 142.939 515.29 137.64V106.515Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-110-outside-1_75_837)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 142.678V153.202H597.568C593.806 153.202 591.098 152.418 589.443 150.851C587.788 149.283 586.96 147.007 586.96 144.021C582.597 150.59 576.24 153.874 567.889 153.874C561.419 153.874 556.228 152.381 552.316 149.395C548.404 146.41 546.448 142.305 546.448 137.08C546.448 131.183 548.554 126.668 552.767 123.533C556.98 120.323 563.112 118.718 571.161 118.718H585.719V115.248C585.719 112.038 584.59 109.538 582.333 107.746C580.076 105.88 576.954 104.947 572.967 104.947C569.431 104.947 566.497 105.731 564.165 107.299C561.908 108.791 560.554 110.807 560.102 113.344H548.14C548.742 107.597 551.3 103.156 555.814 100.021C560.328 96.8118 566.234 95.207 573.531 95.207C581.28 95.207 587.261 96.9984 591.474 100.581C595.687 104.164 597.793 109.314 597.793 116.031V138.647C597.793 141.334 599.072 142.678 601.63 142.678H604ZM585.719 127.675H570.597C566.835 127.675 563.939 128.422 561.908 129.914C559.877 131.333 558.861 133.46 558.861 136.296C558.861 138.759 559.801 140.737 561.682 142.23C563.638 143.723 566.271 144.469 569.581 144.469C574.622 144.469 578.534 143.126 581.318 140.439C584.176 137.752 585.643 134.169 585.719 129.69V127.675Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-110-outside-1_75_837)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_837",
    x1: 410.5,
    y1: 62,
    x2: 410.5,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_837",
    x1: 410.5,
    y1: 62,
    x2: 410.5,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_837",
    x1: 410.5,
    y1: 62,
    x2: 410.5,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_837",
    x1: 410.5,
    y1: 62,
    x2: 410.5,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_837",
    x1: 410.5,
    y1: 62,
    x2: 410.5,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 822,
    height: 224,
    rx: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaSmall);
export default __webpack_public_path__ + "static/media/beta-small.79696ee337f21a142ba861ee1b86c6ba.svg";
export { ForwardRef as ReactComponent };